import { gql } from '@apollo/client'
import { isEmpty } from 'ramda'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { usePaginatedQuery } from '../../../../utils/apollo/_helpers/pagination'
import { removeLocalStorageItem } from '../../../../utils/helpers/localStorage'
import PaginationControl from '../../../../components/helpers/PaginationControl'
import StatePresenter from '../../../../packages/kiti/components/helpers/StatePresenter'
import { useRouteParam } from '../../../../utils/routes/helpers/useParam'

const Context = React.createContext()
const { Provider } = Context
export const useServiceOrdersState = () => React.useContext(Context) || {}
export const useServiceOrders = () => useServiceOrdersState()?.serviceOrdersHistory || []

const QUERY = gql`
  query ServiceOrdersHistory($page: Int, $token: String, $placeId: Int, $assetId: Int) {
    serviceOrdersHistory(page: $page, token: $token, placeId: $placeId, assetId: $assetId) {
      id
      name
      yearlyId
      insertedAt
      endDate
      scheduling
      childrenCount
      resumeToken
      events {
        id
        eventDate
        status {
          id
          name
          color
        }
        reason {
          id
          name
        }
        description
        user {
          id
          name
        }
      }
      priority {
        id
        name
      }
      status {
        id
        name
        label
        color
      }
      checklist {
        id
        name
      }
      place {
        id
        name
        resume
      }
      asset {
        id
        name
        type {
          id
          name
        }
      }
      group {
        id
        name
      }
      groups {
        id
        name
      }
      user {
        id
        name
      }
    }
  }
`

const ServiceOrdersLoader = ({ children, search, filter, uncontrolledChildren }) => {
  const token = useRouteParam('token')
  const entityId = useRouteParam('entityId')
  const entityType = useRouteParam('entityType')

  const [page, setPage] = React.useState(1)

  if (isEmpty(filter) && !search) {
    filter = { ...filter, with_parent: false }
  }

  const { data, refetch, fetchMore, ...state } = usePaginatedQuery(QUERY, {
    variables: {
      page,
      token,
      search,
      ...(entityType === 'place' ? { placeId: parseInt(entityId) } : {}),
      ...(entityType === 'asset' ? { assetId: parseInt(entityId) } : {})
    },
    flexiblePollInterval: 25000,
    client: serviceOrdersClient
  })

  React.useEffect(() => {
    removeLocalStorageItem('asset')
  }, [])

  return (
    <Provider value={data}>
      <StatePresenter {...state} uncontrolledChildren={uncontrolledChildren}>
        {children}
      </StatePresenter>
      <PaginationControl fetchMore={fetchMore} page={page} onChange={setPage} state={state} />
    </Provider>
  )
}

export default ServiceOrdersLoader
